import { render, staticRenderFns } from "./TokenVerification.vue?vue&type=template&id=6dc451f8&scoped=true"
import script from "./TokenVerification.vue?vue&type=script&lang=ts"
export * from "./TokenVerification.vue?vue&type=script&lang=ts"
import style0 from "./TokenVerification.vue?vue&type=style&index=0&id=6dc451f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc451f8",
  null
  
)

export default component.exports